import { useState } from 'react';
import { KIcon } from '@karnott/icons';
import { Button } from './button';
import { ExpandableButton } from './expandableButton';

type ExpandableToggle = {
  key: string;
  Icon: KIcon;
  /** Tooltip and accessible name of the toggle */
  message: string;
  active: boolean;
  onToggle: () => void;
};

type Props = {
  /** The toggles to display, falsy entries are skipped */
  toggles: (ExpandableToggle | false | null | undefined)[];
  /** Tooltip of the expand button while collapsed */
  expandMessage: string;
};

/** An expandable group of on/off toggles, whose trigger counts the active ones while collapsed */
export function ExpandableToggles({ toggles, expandMessage }: Props) {
  const [expanded, setExpanded] = useState(false);

  const shownToggles = toggles.filter((toggle): toggle is ExpandableToggle => !!toggle);
  const activeCount = shownToggles.filter((toggle) => toggle.active).length;

  return (
    <ExpandableButton
      buttons={shownToggles.map((toggle) => (
        <Button
          key={toggle.key}
          Icon={toggle.Icon}
          onClick={toggle.onToggle}
          primary
          outlinedNeutral
          outlined={toggle.active}
          badge={toggle.active}
          message={toggle.message}
          tooltipOrientation="top"
          noWrap
        />
      ))}
      expandButtonProps={{
        badge: (!expanded && activeCount) || false,
        outlined: activeCount > 0 && !expanded,
        large: false,
        message: expanded ? undefined : expandMessage,
        tooltipOrientation: 'left',
        noWrap: true,
      }}
      onExpand={() => setExpanded(true)}
      onShrink={() => setExpanded(false)}
    />
  );
}
